import React from "react";
import type { SelectionMode } from "react-aria-components";
import type { itemText } from "./DropdownItem.css.ts";

export type TextSize = keyof typeof itemText.classNames.variants.size;
export interface DropdownItemContextProps {
  size: TextSize;
  selectionMode?: SelectionMode;
}

export const DropdownItemContext =
  React.createContext<DropdownItemContextProps>({
    size: "m",
    selectionMode: "single",
  });
